<template lang="pug">
#Dtt
  navbarmenu(v-if="Object.keys(magicNav).length" class="print:tw-hidden")
  router-view(class="tw-min-h-[80dvh]")
  notifications(group="global",position="bottom right")
  notifications(group="booking",position="bottom right" :closeOnClick="true")
    template(slot='body' slot-scope='props')
      div(style="padding: 20px;box-shadow: 1px 1px 1px 1px silver;background-color: beige;border-left:3px solid black;")
        .media-content
          .content
            p
              strong {{ props.item.title }} &nbsp;
                b-icon(icon="props.item.data.icon" pack="fas" :style="props.item.data.iconstyle" size="medium")
                div.custom-template-close(@click="props.close")
                  .delete.is-small(style="right: 11px;position: absolute;top: 11px;")
              br
              | {{ props.item.text }}
              br
  loader-component(v-if="showProgress")
  FooterComponent(v-if="user && Object.keys(user).length" class="print:tw-hidden")
</template>

<script>
 import navbarmenu from "@/components/NavbarMenu.vue";
 import LoaderComponent from "@/components/LoaderComponent.vue"
 import { decompressFromUTF16 as decompress }  from 'lz-string';
 import { mapGetters, mapActions } from 'vuex';
 import FooterComponent from '@/components/FooterComponent.vue'

 const hotJar = () => {
   (function(h,o,t,j,a,r){
     h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
     h._hjSettings={hjid:1895030,hjsv:6};
     a=o.getElementsByTagName('head')[0];
     r=o.createElement('script');r.async=1;
     r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
     a.appendChild(r);
     })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  };
  const clarity = () => {
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "ntcgkx3hp2");
  }
  export default {
    name: "Dtt",
    components: {
      navbarmenu,
      LoaderComponent,
      FooterComponent,
    },
    data() {
      return {
        showNavbar:true,
        url: 'https://cdn3.iconfinder.com/data/icons/flat-actions-icons-9/792/Tick_Mark_Dark-512.png',
        showChildComponent: false,
        isLoading: true,
        isAnActiveComponentTab: true,
      }
    },
    computed:{
      ...mapGetters('auth',[
        'user',
        'magicNav'
      ]),
      ...mapGetters('global', [
          'showProgress',
          'production'
      ])
    },
    mounted() {
      this.setMenu();
      this.getActiveUser();
      !window.localStorage.getItem('user') ? this.$router.push('/login') : false;
      this.$i18n.locale = window.localStorage.getItem('locale');
    },
    created(){
      this.setProduction();
      if (this.production) {
        hotJar();
        clarity();
      }
    },
    methods: {
      ...mapActions('auth', [
        'getActiveUser',
        'setMenu'
      ]),
      ...mapActions('global', ['setProduction'])
    }
  }
</script>



<style lang="css">
  .columns {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }
  .table td{
    vertical-align: middle !important;
    padding: 0.1em 0.5em !important;
  }
  #Dtt{
    padding:0px 0px 0px 0px;
  }
</style>

<style lang="scss">
  @import "@/assets/scss/main.scss";
  .autocomplete .dropdown-menu {
    min-width:none;
    max-width: none;
  }
</style>



// WEBPACK FOOTER //
// src/Dtt.vue